"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BadgeCertificateInfo;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var s = {
  root:
  /*#__PURE__*/
  (0, _emotion.css)("display:flex;align-items:center;line-height:2;"),
  icon: function icon(theme, type) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("margin-right:4px;margin-bottom:3px;", type === 'certificate' ?
      /*#__PURE__*/
      (0, _emotion.css)("fill:", theme.color.dark.emerald, ";") : '', ";")
    );
  },
  text: function text(theme) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-size:10px;font-weight:500;letter-spacing:2px;text-transform:uppercase;color:", theme.color.dark.iron, ";")
    );
  }
};

function BadgeCertificateInfo(props) {
  var type = props.type,
      theme = props.theme,
      badgeInfoClassName = props.badgeInfoClassName;
  var iconName = type === 'badge' ? 'medal' : 'star';
  var text = type === 'badge' ? 'Badge' : 'Certificate';
  return _react.default.createElement("div", {
    className: s.root
  }, _react.default.createElement(_Icon.default, {
    type: iconName,
    className: s.icon(theme, type)
  }), _react.default.createElement("span", {
    className: (0, _classnames.default)(s.text(theme), badgeInfoClassName)
  }, text));
}